import { Box } from '@mui/material';
import { useStyles } from './Reasoning.styles';
import { fontWeight, Text, textLevel } from '../../atoms/typography';
import { colors } from '../../../colors';
import { Icons } from '../../../icons';

const Reasoning = ({ note, isDiagnosis }) => {
  const classes = useStyles();

  const caseNoteData = [
    {
      title: 'Reasoning',
      description: note?.reasoning,
    },
    {
      title: 'Quote',
      description: note?.transcriptQuote,
    },
  ];

  const diagnosisData = [
    {
      title: 'Reasoning',
      description: note?.reasoning,
    },
    {
      title: 'Quote',
      description: note?.transcriptQuote,
    },
    {
      title: 'Criteria',
      description: note?.criteriaAssessment,
    },
  ];

  const contentToDisplay = isDiagnosis ? diagnosisData : caseNoteData;

  const renderContent = () => {
    const filteredContent = contentToDisplay.filter((item) => {
      if (item.title === 'Reasoning') {
        return item.description;
      } else if (item.title === 'Quote') {
        return item.description;
      } else if (item.title === 'Criteria') {
        return item.description && item.description.length > 0;
      }
      return true;
    });

    return (
      <Box className={classes.reasoningContainer}>
        {filteredContent.map((item, index) => (
          <Box key={index} className={classes.reasoningSection}>
            <Text level={textLevel.M} weight={fontWeight.SEMI_BOLD} color={colors.neutral900}>
              {item.title}
            </Text>
            {item.title === 'Criteria' ? (
              <Box className={classes.criteriaContainer}>
                {item.description.map((criteria, index) => (
                  <Box key={index} className={classes.criteriaItem}>
                    <Text level={textLevel.S} weight={fontWeight.MEDIUM} color={colors.neutral600}>
                      {criteria.description}
                    </Text>
                    <Box>
                      <Icons
                        glyph={criteria.met ? 'check-circle' : 'clear-circle'}
                        color={criteria.met ? colors.success500 : colors.destructive500}
                        width={20}
                        height={20}
                      />
                    </Box>
                  </Box>
                ))}
              </Box>
            ) : (
              <Text level={textLevel.S} weight={fontWeight.MEDIUM} color={colors.neutral600}>
                {item.description || "No quote found"}
              </Text>
            )}
          </Box>
        ))}
      </Box>
    );
  };

  return <Box>{renderContent()}</Box>;
};

export { Reasoning };
